/**
 * @Author: 左建
 * @Date: 2022/6/21 10:13
 * @LastEditTime: 2022/6/21 10:13
 * @Description:  创建考试相关接口
*/

import { get, post } from "@/utils/request"

/**
 * 获取阅卷老师列表
 * @param? data: {
 * pageIndex // 页数
 * pageSize // 每页条数
 * sortBy: "ID" // 根据什么排序
 * sortOrder: "Asc" // 升序排列还是降序}
 * @return {Promise<unknown>}
 */
export function getTeacherList(data) {
    data = data || {
        pageIndex: 1,
        pageSize: 100,
        sortBy: "ID",
        sortOrder: "Asc"
    }
    return post("/Website/Exam/GetTeacher", undefined, undefined, data)
}
